<template>
    <div>
        <h4 style="text-align: center">เปลี่ยนสถานะเช็คเป็น P</h4>
        <br>
        <div class="row form-group">
            <div class="col-4 text-right">
                <label>วันที่นำเข้าเช็ค P</label>
            </div>
            <div class="col-6">
                <date-picker
                        v-model="date"
                        type="date"
                        :format="changeFormat"
                        :lang="lang"
                        confirm
                        placeholder="วันที่นำเข้าเช็ค" >
                </date-picker>&nbsp;&nbsp;
            </div>
        </div>
        <div class="col text-center">
            <button type="button" class="btn btn-success" @click="submitData">บันทึก</button>&nbsp;&nbsp;
            <button type="button" class="btn btn-outline-secondary" @click="cancelData">ยกเลิก</button>
        </div>
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import moment from "moment";

export default {
        name: "cheque-status-p",
        data(){
          return{
              date : "",
              changeFormat: {
                  stringify: (date) => {
                      if(date && moment(date).format('MM') == '02' && moment(date).format('DD') == '29')
                          return '29/02/' + moment(date).add(543, 'y').format('YYYY');
                      return date ? moment(date).add(543, 'y').format('DD/MM/YYYY') : null
                  },
                  parse: (value) => {
                      return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                  }
              },
              lang: {
                  days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                  months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                  pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                  placeholder: {
                      date: 'วว/ดด/ปปปป',
                  }
              },
          }
        },
        components : {
            DatePicker
        },
        methods:{
            submitData(){
                if(this.date){
                    this.date = moment(this.date).format("YYYY-MM-DD");
                }
                else{
                    this.date = "";
                }
                this.$emit("submit",this.date);
            },
            cancelData(){
                this.$emit("submit",false)
            }
        }
    }
</script>

<style scoped>

</style>
